import {
    PixelType,
    ResponsiveDictionary,
    ResponsiveFontSizes,
    ResponsiveType,
} from '@sport1/react-elements/core/styles/utils/transformProps/types'
import { spacings } from '../DesignSystem/spacings'
import { ResponsiveFontVariants } from '../Theme/Fonts/FontTypes'
import fontSizeVariants from '../DesignSystem/font/fontSize'
import { ArticleToolBarSize } from './types'

interface SizeSettings {
    height: ResponsiveDictionary
    arrowAndLabelContainerWidth: ResponsiveType<number>
    imageWidth: ResponsiveType<number>
    homeIconSize: ResponsiveFontSizes
    descriptionFontSize: ResponsiveFontVariants
    playIconWrapper: ResponsiveType<number>
    playIconPosition: ResponsiveType<number>
    playIconSize: ResponsiveType<PixelType>
    scrollRightIconSize: ResponsiveType<PixelType>
    descriptionPadding: ResponsiveType<PixelType>
}

type SizeStyles = {
    [size in ArticleToolBarSize]: SizeSettings
}

const useArticleBottomBarStyles = (size: ResponsiveType<ArticleToolBarSize>): SizeSettings => {
    const sizeStyles: SizeStyles = {
        S: {
            height: 60,
            arrowAndLabelContainerWidth: 52,
            imageWidth: 90,
            homeIconSize: fontSizeVariants['font-size-8'],
            descriptionFontSize: 'Body-M',
            playIconWrapper: 16,
            playIconSize: fontSizeVariants['font-size-2'],
            playIconPosition: 6,
            scrollRightIconSize: fontSizeVariants['font-size-4'],
            descriptionPadding: spacings['spacing-5'],
        },
        M: {
            height: 80,
            arrowAndLabelContainerWidth: 63,
            imageWidth: 120,
            homeIconSize: fontSizeVariants['font-size-10'],
            descriptionFontSize: 'Title-S',
            playIconWrapper: 24,
            playIconPosition: 6,
            playIconSize: fontSizeVariants['font-size-4'],
            scrollRightIconSize: fontSizeVariants['font-size-8'],
            descriptionPadding: spacings['spacing-7'],
        },
        L: {
            height: 100,
            arrowAndLabelContainerWidth: 85,
            imageWidth: 150,
            homeIconSize: fontSizeVariants['font-size-10'],
            descriptionFontSize: 'Title-L',
            playIconWrapper: 32,
            playIconPosition: 8,
            playIconSize: fontSizeVariants['font-size-8'],
            scrollRightIconSize: fontSizeVariants['font-size-10'],
            descriptionPadding: spacings['spacing-8'],
        },
    }

    const getStyle = (sizeKey: ArticleToolBarSize) => ({
        ...sizeStyles[sizeKey],
    })

    if (Array.isArray(size)) {
        const styles = size.map(getStyle)
        return {
            height: styles.map(s => s.height) as ResponsiveDictionary,
            homeIconSize: styles.map(s => s.homeIconSize) as ResponsiveFontSizes,
            imageWidth: styles.map(s => s.imageWidth) as ResponsiveType<number>,
            arrowAndLabelContainerWidth: styles.map(
                s => s.arrowAndLabelContainerWidth
            ) as ResponsiveType<number>,
            descriptionFontSize: styles.map(s => s.descriptionFontSize) as ResponsiveFontVariants,
            playIconWrapper: styles.map(s => s.playIconWrapper) as ResponsiveType<number>,
            playIconPosition: styles.map(s => s.playIconPosition) as ResponsiveType<number>,
            playIconSize: styles.map(s => s.playIconSize) as ResponsiveType<PixelType>,
            scrollRightIconSize: styles.map(
                s => s.scrollRightIconSize
            ) as ResponsiveType<PixelType>,
            descriptionPadding: styles.map(s => s.descriptionPadding) as ResponsiveType<PixelType>,
        }
    }
    const singleStyle = getStyle(size)
    return {
        height: singleStyle.height as ResponsiveDictionary,
        homeIconSize: singleStyle.homeIconSize as ResponsiveFontSizes,
        imageWidth: singleStyle.imageWidth as ResponsiveType<number>,
        arrowAndLabelContainerWidth:
            singleStyle.arrowAndLabelContainerWidth as ResponsiveType<number>,
        descriptionFontSize: singleStyle.descriptionFontSize as ResponsiveFontVariants,
        playIconWrapper: singleStyle.playIconWrapper as ResponsiveType<number>,
        playIconPosition: singleStyle.playIconPosition as ResponsiveType<number>,
        playIconSize: singleStyle.playIconSize as ResponsiveType<PixelType>,
        scrollRightIconSize: singleStyle.scrollRightIconSize as ResponsiveType<PixelType>,
        descriptionPadding: singleStyle.descriptionPadding as ResponsiveType<PixelType>,
    }
}

export default useArticleBottomBarStyles
